import React from 'react';
import './style.css'

function ExclamationSymbol(props) {
  let r = props.r
  let textStyle = {'fontSize': 1.7 * r + 'px'}

  return (
    <svg width={(2 * r + 5) + 'px'} height={(2 * r) + 'px'}>
      <g className="exclamation-symbol" transform={'translate(' + r + ',' + r + ')'}>
        <circle r={r} />
        <text y={0.62 * r} style={textStyle}>!</text>
      </g>
    </svg>
  );
}

export default ExclamationSymbol;



// WEBPACK FOOTER //
// ./src/ExclamationSymbol/index.js